import RewardPreviewScreen from "./RewardPreviewScreen";

export default RewardPreviewScreen;